import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isOwnerRole, isTopRole } from "../constants/roleRules";
import { fetchRolesAPI } from "../features/roles/rolesAPI";

// The role names the signed-in admin may give an employee — what the backend
// allows (checkRoleHierarchy): every role for an Owner, every role but the top
// ones for an Admin, otherwise the roles listed in its own role's
// canManageRoles.
const useAssignableRoles = () => {
  const { roleName, managedRoles } = useSelector((state) => state.user);
  const isTop = isTopRole(roleName);
  const isOwner = isOwnerRole(roleName);
  const [allRoles, setAllRoles] = useState([]);

  useEffect(() => {
    if (!isTop) return undefined;
    let cancelled = false;
    fetchRolesAPI()
      .then((response) => {
        if (cancelled) return;
        const names = (Array.isArray(response?.data) ? response.data : [])
          .map((role) => role?.role)
          .filter((name) => name && (isOwner || !isTopRole(name)));
        setAllRoles(names);
      })
      .catch(() => {
        if (!cancelled) setAllRoles([]);
      });
    return () => {
      cancelled = true;
    };
  }, [isTop, isOwner]);

  return isTop ? allRoles : managedRoles || [];
};

export default useAssignableRoles;
